import Select from 'react-select';
import { useState } from 'react';
import { useEffect } from 'react';
import s from './timezone.module.scss'
import { timezoneGroups } from '@entities/profile/model/timezone-picker/tzdata';
import { findTimezoneGroupByEng } from '@entities/profile/lib/timezone-picker/utils';

export const TimezonePicker = ({currentTz, selected, setSelected}) => {
	const [timezones, setTimezones] = useState([])

	const buildTimezones = () => {
		let timezones = [];

		for (const group of timezoneGroups) {
			if (!group.zones.length) {
				continue;
			}
			timezones.push({
				value: group.zones[0].eng,
				label: group.name,
			});
		}

		return timezones;
	};

	useEffect(() => {
		setTimezones(buildTimezones());

		if (currentTz) {
			const currentTimezoneGroup = findTimezoneGroupByEng(currentTz)
			if (currentTimezoneGroup) {
				setSelected({
					label: currentTimezoneGroup.name,
					value: currentTimezoneGroup.zones[0].eng,
				})
			} else {
				// Таймзона вне списка РФ — показываем её как есть, чтобы её можно было сменить
				setSelected({
					label: currentTz,
					value: currentTz,
				})
			}
		}
	}, [currentTz, setSelected])

	return (
		<Select 
			options={timezones}
			onChange={setSelected}
			value={selected}
			className={s.select}
			styles={{
				control: (baseStyles, state) => ({
					...baseStyles,
					outline: 'none',
					boxShadow: 'none',
					width: '100%',
					borderRadius: '.75rem',
					backgroundColor: 'var(--bg-elevated)',
					borderColor: state.isFocused ? 'var(--color-primary-text)' : 'var(--border-default)',
				}),
				valueContainer: (baseStyles) => ({
					...baseStyles,
					padding: 0,
				}),
				singleValue: (baseStyles) => ({
					...baseStyles,
					color: 'var(--text-primary)',
				}),
				placeholder: (baseStyles) => ({
					...baseStyles,
					color: 'var(--text-muted)',
				}),
				multiValue: (baseStyles) => ({
					...baseStyles,
					backgroundColor: 'var(--bg-active)',
					borderRadius: '.5rem',
					color: 'var(--text-primary)',
					padding: '.5rem .35rem',
					"&:hover": {
						background: 'var(--bg-active)'
					}
				}),
				multiValueRemove: (baseStyles) => ({
					...baseStyles,
					cursor: 'pointer',
					"&:hover": {
						background: 'none'
					}
				}),
				menu: (baseStyles) => ({
					...baseStyles,
					borderRadius: 10,
					padding: 8,
					backgroundColor: 'var(--bg-elevated)',
					boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px'
				}),
				option: (baseStyles, {isSelected}) => ({
					...baseStyles,
					padding: '0.5rem 1rem',
					borderRadius: 4,
					color: 'var(--text-secondary)',
					fontSize: '1rem',
					lineHeight: '1.5rem',
					cursor: 'pointer',
					background: isSelected ? 'var(--bg-active)' : 'none', 
					"&:hover": {
						background: 'var(--bg-active)'
					}
				}),
				multiValueLabel: (baseStyles) => ({
					...baseStyles,
					color: 'var(--text-primary)',
					fontSize: '.875rem',
					fontWeight: '500',
					lineHeight: '100%',
				}),
			}}
			isClearable={false}
		/>
	)
}